// Media feature async thunks — reads and writes via the generic
// /api/odl-app/binary-files/ endpoint.  file_type='photo' for site photos,
// file_type='cic-image' for CIC camera captures.

import { createAsyncThunk } from '@reduxjs/toolkit';

import { createBinaryFile, deleteBinaryFile, fetchBinaryFiles, patchBinaryFile } from '@sophocles/api/binaryFiles';
import { normalizeBinaryFileRow } from '@sophocles/features/media/normalize';
import { addToast } from '@sophocles/features/toast';

export const loadCameraImages = createAsyncThunk(
  'images/loadCameraImages',
  async ({ siteId, queryParams }, { rejectWithValue }) => {
    try {
      const data = await fetchBinaryFiles({ fileType: 'cic-image', site_id: siteId, ...queryParams });
      return { ...data, data: (data.data ?? []).map(normalizeBinaryFileRow) };
    } catch (e) {
      return rejectWithValue(e.response?.data ?? e.message);
    }
  },
);

export const deleteCameraImage = createAsyncThunk('images/deleteCameraImage', async (guid, { rejectWithValue }) => {
  try {
    await deleteBinaryFile(guid);
    return guid;
  } catch (e) {
    return rejectWithValue(e.response?.data ?? e.message);
  }
});

export const addSitePhoto = createAsyncThunk('images/addSitePhoto', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await createBinaryFile(data);
    dispatch(addToast({ title: 'Success', message: 'Image Created', level: 'success', dismissible: true }));
    return response;
  } catch (e) {
    return rejectWithValue(e.response?.data ?? e.message);
  }
});

export const editSitePhoto = createAsyncThunk(
  'images/editSitePhoto',
  async ({ id: guid, ...data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await patchBinaryFile(guid, data);
      dispatch(addToast({ title: 'Success', message: 'Image Updated', level: 'success', dismissible: true }));
      return response;
    } catch (e) {
      return rejectWithValue(e.response?.data ?? e.message);
    }
  },
);

export const loadSitePhotos = createAsyncThunk(
  'images/loadSitePhotos',
  async ({ siteId, queryParams }, { rejectWithValue }) => {
    try {
      const data = await fetchBinaryFiles({ fileType: 'photo', site_id: siteId, ...queryParams });
      return { ...data, data: (data.data ?? []).map(normalizeBinaryFileRow) };
    } catch (e) {
      return rejectWithValue(e.response?.data ?? e.message);
    }
  },
);

export const deleteSitePhoto = createAsyncThunk(
  'images/deleteSitePhoto',
  async (guid, { dispatch, rejectWithValue }) => {
    try {
      await deleteBinaryFile(guid);
      dispatch(addToast({ title: 'Success', message: 'Image Deleted', level: 'success', dismissible: true }));
      return guid;
    } catch (e) {
      return rejectWithValue(e.response?.data ?? e.message);
    }
  },
);
